export const Login = 'auth/login'
export const Signup = 'auth/adminSignup'
export const CreateTenant = 'auth/createTenant'
export const getAllTenant = 'auth/getAllTenant'
export const getTenantById = 'auth/getTenantById'
export const getTenantAppConfig = 'auth/getTenantAppConfig'
export const updateTenant = 'auth/updateTenant'
export const deleteTenant = 'auth/deleteTenant'
export const getUserById = 'auth/getUserById'
export const getAllUser = 'auth/getAllUser'
export const addUser = 'auth/addUser'
export const updateUser = 'auth/updateUser'
export const changePassword = 'auth/changePassword'
export const getAllVehicle = 'vehicle/getAllVehicle'
export const getAllVehicleGroup = 'vehicle/getAllVehicleGroup'
export const getAllDriver = 'driver/getAllDriver'
export const addDriver = 'driver/addDriver'
export const updateDriver = 'driver/updateDriver'
export const getDriverById = 'driver/getDriverById'
export const deleteDriver = 'driver'
export const getAllBooking = 'booking/getAllBooking'
export const getAllCustomer = 'customer/getAllCustomer'
export const getAllMaintenance = 'maintenance/getAllMaintenance'
export const getAllInventory = 'parts-inventory/getAllInventory'
export const getAllFuel = 'fuel/getAllFuel'
export const getAllReminder = 'reminder/getAllReminder'
export const getAllIncomeAndExpenses = 'income-expenses/getAllIncomeAndExpenses'
export const addVehicle = 'vehicle/addVehicle'
export const addVehicleGroup = 'vehicle/vehicleGroup'
export const updateVehicle = 'vehicle/updateVehicle'
export const getVehicleById = 'vehicle/id'
export const deleteVehicleById = 'vehicle/id?'
export const getAllDashboardCount = 'vehicle/getAllCount'
export const deleteVehicleGroupById = 'vehicle/deleteVehicleGroupById'

export const addCustomer = 'customer/addCustomer'
export const updateCustomer = 'customer/updateCustomer'
export const getCustomerById = 'customer/getCustomerById'
export const deleteCustomerById = 'customer/id?'
export const addBooking = 'booking'
export const updateBooking = 'booking/{id}'
export const getBookingById = 'booking'
export const deleteBookingById = 'booking'
export const addReminder = 'reminder/addReminder'
export const updateReminder = 'reminder/updateReminder'
export const getReminderById = 'reminder/getReminderById/'
export const deleteReminderById = 'reminder'
export const addIncomeAndExpenses = 'income-expenses/addIncomeExpenses'
export const updateIncomeAndExpenses = 'income-expenses/updateIncomeAndExpenses'
export const getIncomeAndExpensesById = 'income-expenses/getIncomeExpenseById'
export const deleteIncomeAndExpensesById = 'income-expenses'
export const addMaintenance = 'maintenance/'
export const updateMaintenance = 'maintenance'
export const updateStatusMaintenance = 'maintenance/updateMaintenanceStatus'
export const getMaintenanceById = 'maintenance/getMaintenanceById'
export const deleteMaintenanceById = 'maintenance'
export const addInventory = 'parts-inventory/addPartInventory'
export const updateInventory = 'parts-inventory/updatePartInventory'
export const getInventoryById = 'parts-inventory/getInventoryById'
export const deleteInventoryById = 'parts-inventory?'
export const addFuel = 'fuel'
export const updateFuel = 'fuel/updateFuel'
export const getFuelById = 'fuel/getFuelById'
export const deleteFuelById = 'fuel?id'
export const getAllBookingVehicleById = 'vehicle/getAllBookingVehicle'
export const getIncomeByVehicleId = 'vehicle/getIncomeByVehicleId'
export const addPayment = 'payment/addPayment'
export const getPaymentByBookingId = 'payment/getPaymentByBookingId'
export const deletePayment = 'payment/deletePayment'
export const updateBookingStatusbyId = 'booking/updateTripStatus'
export const addCompany = 'company/addCompany'
export const updateCompany = 'company/updateCompany'
export const getCompany = 'company/getAllCompany'
export const getCompanyById = 'company/getCompanyById'
export const deleteCompanyById = 'company/deleteCompany'
export const getBookingByCompanyId = 'company/getBookingByCompanyId'
export const getCustomerByCompanyId = 'company/getCustomerByCompanyId'
export const addCustomerInCompany = 'company/addCustomersInCompany'
export const childAssign = 'customer/assignchild'
